import { useAppDispatch, useAppSelector, useAppStore } from "@/app/appStore";
import {
  selectIsSkuSectionPlanogramVisible,
  selectSelectedGondola,
  setCurrentCamera,
  setGondolaByName,
  setGondolaDropdownValue,
  setSelectedGondola,
  setSelectedSkuSectionId,
  setPlanogramViewVisibility,
  setSelectedCameraMode,
  setGondolaDropdownValueByName,
  setPlanogramOverlayVisibility,
} from "@/entities/annotation";
import { allOption } from "../ui/gondola-select";
import { Gondola } from "@/shared/api";
import { CAMERA_MODES } from "@/entities/annotation/model/consts";
import useCameraHandlers from "../hooks/useCameraHandlers";
import { usePlayer, usePlayerStore } from "@tezzro/player";

const useGondolaHandlers = () => {
  const dispatch = useAppDispatch();
  const store = useAppStore();
  const { getState } = usePlayerStore();
  const player = usePlayer();
  const selectedGondola = useAppSelector(selectSelectedGondola);
  const isSkuSectionPlanogramViewVisible = useAppSelector(
    selectIsSkuSectionPlanogramVisible
  );
  const { cameraData } = useCameraHandlers();

  const handleGondolaChange = (gondola: Gondola | null) => {
    if (!gondola) return;

    if (gondola?.name.toLowerCase() === CAMERA_MODES.ALL) {
      dispatch(setSelectedCameraMode(CAMERA_MODES.ALL));
      dispatch(setGondolaDropdownValue(allOption));
      return;
    }

    const handTrackingCameraId = gondola?.handTrackingCameras?.[0]?.id;
    const shelfTrackingCameraId = gondola?.shelfTrackingCameras?.[0]?.id;

    dispatch(setSelectedGondola(gondola));
    dispatch(setGondolaDropdownValue(gondola));
    dispatch(setSelectedCameraMode(CAMERA_MODES.ALL));

    if (isSkuSectionPlanogramViewVisible && shelfTrackingCameraId) {
      dispatch(setCurrentCamera(shelfTrackingCameraId));
      player.changeCamera(shelfTrackingCameraId);
    } else if (handTrackingCameraId) {
      dispatch(setCurrentCamera(handTrackingCameraId));
      player.changeCamera(handTrackingCameraId);
    }

    if (gondola?.id !== selectedGondola?.id) {
      dispatch(setSelectedSkuSectionId(null));
    }
  };

  const handleClosePlanogramView = () => {
    const handTrackingCameraId =
      store.getState().annotation.annotationData?.cameraId ||
      selectedGondola?.handTrackingCameras?.[0].id;
    const timestamp =
      store.getState().annotation.annotationData?.timestamp ||
      getState().currentTime;

    dispatch(setPlanogramViewVisibility(false));
    dispatch(setPlanogramOverlayVisibility(false));

    if (handTrackingCameraId) {
      dispatch(setCurrentCamera(handTrackingCameraId));
      dispatch(setSelectedCameraMode(CAMERA_MODES.ALL));

      const gondolaName =
        cameraData?.findCameraGondolaName?.(handTrackingCameraId);
      dispatch(setGondolaByName(gondolaName));
      dispatch(setGondolaDropdownValueByName(gondolaName));

      player.seek(timestamp, handTrackingCameraId);
    }
  };

  return {
    handleGondolaChange,
    handleClosePlanogramView,
  };
};

export default useGondolaHandlers;
